import { render, staticRenderFns } from "./AppModal.vue?vue&type=template&id=059f5ddf&scoped=true&"
import script from "./AppModal.vue?vue&type=script&lang=js&"
export * from "./AppModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f5ddf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059f5ddf')) {
      api.createRecord('059f5ddf', component.options)
    } else {
      api.reload('059f5ddf', component.options)
    }
    module.hot.accept("./AppModal.vue?vue&type=template&id=059f5ddf&scoped=true&", function () {
      api.rerender('059f5ddf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/basic/event/modules/AppModal.vue"
export default component.exports